/**
 * @author        yontaek@zumper.com (Yon Taek Chung)
 * @copyright     Copyright (c) 2023, Zumper
 * @description   Reviews api bizo
 */

import type {
  RatingsAndReviewsModalCounts,
  RatingsAndReviews as RatingsAndReviewsType,
  RawRatingsAndReviews,
  RawReview,
} from '@zcode/state-type'
import { Bizo, autoclass } from '../../shared/bizos/base'

export const DEFAULT_MODAL_COUNTS: RatingsAndReviewsModalCounts = {
  excellentCount: null,
  veryGoodCount: null,
  goodCount: null,
  poorCount: null,
}

const DEFINITION = {
  reviews: (t: RatingsAndReviewsType) => {
    if (t?._data?.reviews?.length) {
      return t._data.reviews.map((data: RawReview) => {
        const {
          review_id: id,
          reviewed_on: reviewedOn,
          arrived_on: stayedOn,
          listing_id: listingId,
          rating,
          text: review,
          full_name: name,
        } = data

        return {
          id,
          listingId,
          name,
          rating,
          review,
          reviewedOn: reviewedOn * 1000,
          stayedOn: stayedOn * 1000,
        }
      })
    }

    return []
  },
  totalCount: 'total_count',
} as const

export default autoclass<RatingsAndReviewsType, RawRatingsAndReviews>(
  'RatingsAndReviews',
  class RatingsAndReviews extends Bizo<RatingsAndReviewsType, RawRatingsAndReviews> {},
  DEFINITION,
  null
)
